
import { Component } from "vue-property-decorator";
import { Answer } from "@/lib/model/exam/result";
import { Report } from "@/lib/model/exam/candidate";

import ResultTs from "./result-ai-report";

//子组件目录
import Comp0 from "./component/comp0.vue"; //0123无实际顺序，仅作便捷区分  抬头
import Comp1 from "./component/comp1.vue"; //个人总览
import Comp2 from "./component/comp2.vue"; //ai总览
import Comp3 from "./component/comp3.vue"; //ai维度分析
import Comp4 from "./component/comp4.vue"; //英语水平
import Comp5 from "./component/comp5.vue"; //普通话水平
import Comp6 from "./component/comp6.vue"; //心理测评 dvf1.0
import Comp6inner1 from "./component/comp6-1.vue"; //DISC性格测试
import Comp6inner2 from "./component/comp6-2.vue"; //大五人格标准版 OCEAN人格评估
import Comp6inner3 from "./component/comp6-3.vue"; //大五人格 60题
import Comp6inner4 from "./component/comp6-4.vue"; //dvf2.0
import Game from "./component/game.vue"; //打气球游戏
import Comp8 from "./component/comp8.vue"; //回答记录
import Comp9 from "./component/comp9.vue"; //作弊风险检测
import Comp10 from "./component/comp10.vue"; //报告页-阅读指引
import Comp11 from "./component/comp11.vue"; //背景调查
import Comp12 from "./component/comp12.vue"; //手部检测
import Comp13 from "./component/comp13.vue"; //辨色检测
import LowerRightCorner from "./component/lower-right-corner/index.vue"; // 右下角功能按钮
import Login from "./login.vue"; //提取码登录

//more after today

@Component({
  components: {
    Comp0,
    Comp1,
    Comp2,
    Comp3,
    Comp4,
    Comp5,
    Comp6,
    Comp6inner1,
    Comp6inner2,
    Comp6inner3,
    Comp6inner4,
    Comp8,
    Comp9,
    Comp10,
    Comp11,
    Comp12,
    Comp13,
    Game,
    LowerRightCorner,
    Login
  }
})
export default class PaperResultReport extends ResultTs {
  // connectCode = "";
  // candidate = new Candidate(); //候选人信息 主表
  // all = new CandidateResult(); //候选人信息 所有表
  colorRes = { 0: "#5654DC", 1: "#19C976", 2: "#19C976", 3: "#19C976" };

  get getCardSort() {
    const list = this.all.reportShowConfigV5;
    if (list.length < 2) return [];
    console.log(
      "getCardSort",
      list
        .filter((item: any) => !item.isHidden)
        .filter((item: any) => item.sort > 0)
        .sort((a: any, b: any) => a.sort - b.sort)
    );
    return list
      .filter((item: any) => !item.isHidden)
      .filter((item: any) => item.sort > 0)
      .sort((a: any, b: any) => a.sort - b.sort);
  }
  // 是否展示阅读指引
  get showReadGuide() {
    return !!this.all.reportShowConfigV5.find(
      item => item.name === "报告阅读指引"
    );
  }
  created() {
    //
  }

  setPdfIng(ing: boolean) {
    console.log("🚀 ~ PaperResultReport ~ setPdfIng ~ ing:", ing);
    this.pdfIng = ing;
  }

  // 心理测评，判断条件抽离，方便在下载 pdf 的时候，在阅读指引模块加载不同的心理测评的阅读指引
  getPsycCondition(comp: any) {
    const psycDvf1 =
      comp.name === "DVF1.0心理风险测量" &&
      !comp.isHidden &&
      this.mindData._isAssignedFlag &&
      this.Show("hiddenPsyc") &&
      this.mindData.psycResult.psycGaugeId === 5;

    const psycDvf2 =
      comp.name === "DVF2.0心理风险测量" &&
      !comp.isHidden &&
      this.mindData._isAssignedFlag &&
      this.Show("hiddenPsyc") &&
      this.mindData.tacPsycResult.psycGaugeId === 1;

    const psycDisc =
      comp.name === "DISC性格测试" &&
      this.mindData._isAssignedFlag &&
      this.mindData.psycResult.psycGaugeId === 3 &&
      !comp.isHidden;

    const psycOcean =
      comp.name === "OCEAN人格评估" &&
      this.mindData._isAssignedFlag &&
      this.Show("hiddenPsyc") &&
      this.mindData.psycResult.psycGaugeId === 1 &&
      !comp.isHidden;

    const psycDaWu =
      comp.name === "大五人格60题版" &&
      this.mindData._isAssignedFlag &&
      this.mindData.psycResult.psycGaugeId === 4 &&
      this.Show("hiddenPsyc") &&
      !comp.isHidden;

    return {
      psycDvf1,
      psycDvf2,
      psycDisc,
      psycOcean,
      psycDaWu
    };
  }

  // 获取 PDF 中需要展示的 心理测评的阅读指引
  getPdfPsycReadingGuide() {
    const list = this.getCardSort;
    const result = {
      psycDvf1: false,
      psycDvf2: false,
      psycDisc: false,
      psycOcean: false,
      psycDaWu: false
    };
    for (let i = 0; i < list.length; i++) {
      const comp = list[i];
      const {
        psycDvf1,
        psycDvf2,
        psycDisc,
        psycOcean,
        psycDaWu
      } = this.getPsycCondition(comp);
      if (psycDvf1) {
        result.psycDvf1 = true;
      }
      if (psycDvf2) {
        result.psycDvf2 = true;
      }
      if (psycDisc) {
        result.psycDisc = true;
      }
      if (psycOcean) {
        result.psycOcean = true;
      }
      if (psycDaWu) {
        result.psycDaWu = true;
      }
    }
    return result;
  }

  // 缓存提取码对应的面试id
  reportCertiCodeCacheExamId = 0;
  // 是否需要提取码
  async needPassword(retryCount = 0): Promise<boolean | undefined> {
    try {
      const res = await Report.getInfo({
        connectCode: this.connectCode,
        tid: this.$route.query.tid as string
      });
      this.reportCertiCodeCacheExamId = res.reportCertiCodeCacheExamId;
      return res.needReportCertiCode;
    } catch (e) {
      console.error(e);
      // 可以根据重试次数决定是否再次调用
      if (retryCount < 3) {
        // 假设最多重试3次
        return this.needPassword(retryCount + 1);
      } else {
        // 达到最大重试次数后
        this.$message.error("网络不佳，请稍后重试吧");
      }
    }
  }

  showLogin = false;
  login() {
    this.showLogin = false;
    this.loadPage();
  }

  async checkPwd() {
    const needPwd = await this.needPassword(); //此处不封try catch，网络不通就需要停在这里
    if (needPwd) {
      //先判缓存的提取码是否正确
      const pass = await (this.$refs as any).login.checkLocalstroage();
      //不正确则展示提取码页面
      if (!pass) {
        this.showLogin = true;
      }
      return pass;
    }
    return true; //不需要提取码
  }

  async mounted() {
    this.connectCode = this.$route.query.connectCode as string;
    //是否需要输入提取码
    const pass = await this.checkPwd();
    if (!pass) return;
    this.loadPage();
  }

  loadPage() {
    this.open().finally(() => {
      if (this.$route.query.autoDownload === "1") {
        setTimeout(() => {
          // this.downPDF();
        }, 2000);
      }
    });
  }

  getOptionModel(name: string) {
    return this.all.reportShowConfigV5.find((item: any) => item.name === name);
  }

  get gameQi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 1;
    });
    // console.log("打气球：", t, this.all?.questionAnswerMap);
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
}
